<style lang="stylus">
    .ganttotherdays_table
        width 100%
        border-color: var(--border-color-ganttotherdays_table);
        .ivu-table
            background-color var(--bg-color-tertiary)
        .ivu-table td, .ivu-table th
            height 32px
            color var(--text-color-primary)
        .ivu-table td
            background-color var(--bg-color-tertiary)
            border-color var(--border-color-ganttotherdays_table-td)
        .ivu-table th
            background-color var(--bg-color-ganttotherdays_table-th)
            border-color var(--border-color-ganttotherdays_table-th);
        .ivu-table:before, .ivu-table:after
            background-color var(--border-color-ganttotherdays_table)
        .ivu-table-cell
            padding 0
        .ivu-table-row-highlight td
            background rgba(0, 0, 0, 0.04)
        .ivu-table-row-hover td
            background rgba(0, 0, 0, 0.04) !important
        span
            width 100%
            padding-left 7px
            text-overflow ellipsis
            overflow hidden
            white-space nowrap
            pointer-events none
        .otherdays_edit
            position relative
            width 100%
            height 100%
            .ivu-date-picker
                display block
            .ivu-input-suffix
                display none
        input
            border none !important
            box-shadow none !important
            height 100%
            color #222
            border-radius 0 !important
    .ganttod-btn
        display flex
        justify-content space-around
        width 30%
        margin-top 20px
    .gantt_polygon
        position absolute
        right 8px
        top 10px
        width 6px
        height 4px
        pointer-events none
</style>
<template>
    <Table
        class="ganttotherdays_table"
        height="90"
        ref="ganttTable"
        border
        :columns="columns"
        :data="tempData"
        highlight-row
        @on-row-click="handleSelect"
    >
        <template slot-scope="{ row, index }" slot="otherdays_name">
            <Input type="text" size="small" v-model="editName" @on-blur="handleChangeName" v-if="editIndex === index" />
            <span v-else>{{ row.otherdays_name }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="otherdays_start">
            <div class="otherdays_edit" v-if="editIndex === index">
                <DatePicker
                    v-model="editStart"
                    size="small"
                    type="date"
                    :transfer="true"
                    :clearable="false"
                    @on-change="handleChangeStart"
                ></DatePicker>
                <iconSymbol class="gantt_polygon" name="polygon" />
            </div>
            <span v-else>{{ getDateStr(row.otherdays_start) }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="otherdays_end">
            <div class="otherdays_edit" v-if="editIndex === index">
                <DatePicker v-model="editEnd" size="small" type="date" :transfer="true" :clearable="false" @on-change="handleChangeEnd"></DatePicker>
                <iconSymbol class="gantt_polygon" name="polygon" />
            </div>
            <span v-else>{{ getDateStr(row.otherdays_end) }}</span>
        </template>
    </Table>
    <!-- <div class="ganttod-btn">
            <Button @click="handleConfirm">{{ $t('confirm') }}</Button>
            <Button @click="handleAdd">{{ $t('addLine') }}</Button>
            <Button @click="handleDel" :disabled="tempData.length <= 5">{{ $t('delLine') }}</Button>
        </div> -->
</template>
<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class GanttOtherDay extends Vue {
        @Prop()
        data;
        tempData = [];
        columns = [];
        editIndex = -1;
        editName = null;
        editStart = null;
        editEnd = null;

        getDateStr(time) {
            let datetime = new Date(time);
            let year = datetime.getFullYear();
            let month: any = datetime.getMonth() + 1; //js从0开始取
            let date: any = datetime.getDate();

            if (month < 10) {
                month = "0" + month;
            }
            if (date < 10) {
                date = "0" + date;
            }

            return time ? `${year}-${month}-${date}` : "";
        }
        handleSelect(row, index) {
            // 记录id，同id不再更新
            if (this.editIndex == index) return;
            console.log("select");
            this.editName = row.otherdays_name;
            this.editStart = row.otherdays_start ? new Date(row.otherdays_start) : "";
            this.editEnd = row.otherdays_end ? new Date(row.otherdays_end) : "";
            this.editIndex = index;
            this.$emit("selectGanttLine", index);
        }
        handleCancel() {
            this.$emit("changeGanttData", {
                data: null,
                index: this.editIndex,
            });
            (this.$refs.ganttTable as any).clearCurrentRow();
            this.editIndex = -1;
        }
        handleChangeName() {
            if (this.tempData[this.editIndex]) {
                this.tempData[this.editIndex].otherdays_name = this.editName;
                this.$emit("changeGanttData", {
                    data: this.tempData[this.editIndex],
                    index: this.editIndex,
                });
            }
        }
        handleChangeStart(data) {
            this.editStart = new Date(data);
            if (this.tempData[this.editIndex]) {
                this.tempData[this.editIndex].otherdays_start = this.editStart;
                this.$emit("changeGanttData", {
                    data: this.tempData[this.editIndex],
                    index: this.editIndex,
                });
            }
        }
        handleChangeEnd(data) {
            this.editEnd = new Date(data);
            if (this.tempData[this.editIndex]) {
                this.tempData[this.editIndex].otherdays_end = this.editEnd;
                this.$emit("changeGanttData", {
                    data: this.tempData[this.editIndex],
                    index: this.editIndex,
                });
            }
        }
        handleKeyPress(e) {
            let code = e.keyCode;
            if (code == 46 || code == 8) {
                this.handleCancel();
            }
        }

        updateTempData() {
            this.tempData = JSON.parse(JSON.stringify(this.data));
            this.editIndex = -1;
            (this.$refs.ganttTable as any).clearCurrentRow();
        }

        mounted() {
            console.log("init tempdata");
            this.tempData = JSON.parse(JSON.stringify(this.data));
            window.addEventListener("keydown", this.handleKeyPress);
        }
        beforeDestroy() {
            window.removeEventListener("keydown", this.handleKeyPress);
        }
        created() {
            this.columns = [
                {
                    title: this.$t("name"),
                    slot: "otherdays_name",
                },
                {
                    title: this.$t("start"),
                    slot: "otherdays_start",
                },
                {
                    title: this.$t("end"),
                    slot: "otherdays_end",
                },
            ];
        }
    }
</script>
<i18n>
{
  "zh": {
    "name": "名称",
    "start": "开始日期",
    "end": "结束日期",
    "addLine": "新增行",
    "delLine": "删除行",
    "noSelect": "未选择行",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "name": "name",
    "start": "Start Date",
    "end": "End Date",
    "addLine": "Add row",
    "delLine": "Delete row",
    "noSelect": "No row selected",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "jp": {
    "name": "名前",
    "start": "開始日",
    "end": "終了日",
    "addLine": "行を追加する",
    "delLine": "行を削除",
    "noSelect": "行が選択されていません",
    "confirm": "確認",
    "cancel": "キャンセル"
  },
  "fr": {
    "name": "Nom",
    "start": "Date de Début",
    "end": "Date de Fin",
    "addLine": "Ajouter",
    "delLine": "Effacer",
    "noSelect": "Aucune ligne sélectionnée",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "name": "Name",
    "start": "Startdatum",
    "end": "Enddatum",
    "addLine": "Hinzufügen",
    "delLine": "Löschen",
    "noSelect": "No se seleccionó ninguna fila",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "es": {
    "name": "nombre",
    "start": "Fecha de inicio",
    "end": "Fecha de finalización",
    "addLine": "Agregar",
    "delLine": "Borrar",
    "noSelect": "未选择行",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "name": "nome",
    "start": "Data Inicial",
    "end": "Data Final",
    "addLine": "Adicionar",
    "delLine": "Excluir",
    "noSelect": "Nenhuma linha selecionada",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "name": "nome",
    "start": "Data di Inizio",
    "end": "Data di Fine",
    "addLine": "Inserisci",
    "delLine": "Elimina",
    "noSelect": "Nessuna riga selezionata",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "name": "名稱",
    "start": "開始日期",
    "end": "結束日期",
    "addLine": "添加行",
    "delLine": "刪除行",
    "noSelect": "未選擇行",
    "confirm": "確認",
    "cancel": "取消"
  },
  "kr": {
    "name": "이름",
    "start": "시작 날짜",
    "end": "종료 날짜",
    "addLine": "행 추가",
    "delLine": "행 삭제",
    "noSelect": "행이 선택되지 않음",
    "confirm": "확인 ",
    "cancel": "취소"
  }
}
</i18n>
